
import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

export function PendingCompanyRequestAlert() {
  const { hasPendingCompanyRequest, pendingCompany } = useAuth();

  if (!hasPendingCompanyRequest || !pendingCompany) {
    return null;
  }

  return (
    <Alert variant="default" className="mb-6 border-2 border-amber-500 bg-amber-50 dark:bg-amber-950/20 shadow-md">
      <AlertCircle className="h-5 w-5 text-amber-500" />
      <AlertTitle className="text-lg font-semibold text-amber-700 dark:text-amber-400">Access Request Pending</AlertTitle>
      <AlertDescription className="mt-2 text-base">
        Your request to join <strong className="font-medium">{pendingCompany.name}</strong> is pending approval from an administrator. 
        You'll be notified when your request is processed.
      </AlertDescription>
    </Alert>
  );
}
